import { handleActions } from 'redux-actions';

import { BillsValue, BillsFiltersCount } from 'ha/types/SearchFilters';

import { BillsFilterState } from './Types';
import { Actions } from '../constants';

const initialState = {
  listingCount: {},
  value: [],
};

interface Payload {
  filtersCount: {
    bills: BillsFiltersCount;
  };
  bills: BillsValue;
}

export default handleActions<BillsFilterState, Payload>(
  {
    [Actions.LOAD_DONE]: (state, { payload }) => ({
      ...state,
      listingCount: payload.filtersCount.bills,
    }),
    [Actions.UPDATE_SEARCH_PARAMS]: (state, { payload: { bills = [] } }) => ({
      ...state,
      value: Array.isArray(bills) ? bills : [bills],
    }),
  },
  initialState,
);

export const getBillsFilter = (state: BillsFilterState) => state.value;
